import React from "react";
import { AuthHeroIllustration } from "./AuthHeroIllustration";

export const AuthHeroPanel: React.FC = () => {
  return (
    <div className="relative h-full min-h-full">
      <AuthHeroIllustration />
    </div>
  );
};
